// Purchase handling is shared in df-cart-actions.js.
// Retour depuis le checkout via bfcache : on recharge la page pour resynchroniser le panier et
// rendre leur état aux boutons « Acheter en 1-Clic » (restés en chargement avant la redirection).
window.addEventListener('pageshow', function(event) {
  if (event.persisted && sessionStorage.getItem('lcf-quick-buy-checkout')) {
    sessionStorage.removeItem('lcf-quick-buy-checkout');
    window.location.reload();
  } else if (!event.persisted) {
    sessionStorage.removeItem('lcf-quick-buy-checkout');
  }
});
